module.exports = __webpack_public_path__ + "media/assets/icons/hamburger-d8dfa6f328bd9f3884806eddb3c72d58.svg";